var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('dv-border-box-7',{staticClass:"message"},[_c('div',[_vm._v("正在识别身份, 请稍候...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }